/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

export const msalConfig = {
    auth: {
        // clientId: "a00f11a6-049d-4707-b5db-c5bb6bcba1db",//dinesh ji Account
        clientId:process.env.REACT_APP_SSO_CLIENT_ID,   //bat 
        // clientId: "fc95b423-54c9-45f5-bd9c-ab7577e73ed7", //bivash
        // clientId: "42a5f597-9c31-452d-94ac-7f666160a3c2",   //test-newapp-newad-p1 

        // authority: "https://login.microsoftonline.com/5db6975b-9bb1-4ff9-bf5f-77e1e3154e16", // Dinesh ji
        authority: process.env.REACT_APP_SSO_AUTHORITY, // bat
        // authority: "https://login.microsoftonline.com/f502b662-14b9-4e3e-b847-05b7d429d2a7",  //bivash
        // authority: "https://login.microsoftonline.com/68625dc3-4621-4599-9df1-af99a0e6160f",  //test-newapp-newad-p1 


        // clientId: "a1802c48-4c90-4ca6-bf2c-4d14764bea2b" ,
        // redirectUri: "https://dev.agri360.bat.net/Agri360/",
        redirectUri:process.env.REACT_APP_BASE_URL,
        postLogoutRedirectUri: process.env.REACT_APP_BASE_URL,

    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
        // cacheLocation: "localStorage", // This configures where your cache will be stored
        // storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        // console.info(message);
                        return;
                    case LogLevel.Verbose:
                        // console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    // scopes: ["User.Read","User.Read.All",'openid']
    // scopes: ['/.default']
    // scopes: ["openid", "profile", "user.read"]

    //    scopes: ['api://a00f11a6-049d-4707-b5db-c5bb6bcba1db/Agri360-test']  //dinesh ji
    scopes: [process.env.REACT_APP_SSO_SCOPE] //bat
    // scopes: ['api://fc95b423-54c9-45f5-bd9c-ab7577e73ed7/SP-AGP-WEBAGRI360-DEV-01'] //bivash
    // scopes: ['api://42a5f597-9c31-452d-94ac-7f666160a3c2/test-newapp-newad-p1'] //test-newapp-newad-p1


};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};